<div class="panel" role="dialog" [attr.aria-label]="'notifications.title' | translate">

  <!-- Cabecera -->
  <div class="panel-header">
    <div class="panel-title-row">
      <h2 class="panel-title">{{ 'notifications.title' | translate }}</h2>
      @if (svc.unseenCount() > 0) {
        <span class="unseen-chip">{{ svc.t('notifications.unseen-count', { n: svc.unseenCount() }) }}</span>
      }
    </div>
    <button mat-icon-button
            class="settings-button"
            [matTooltip]="'notifications.settings.tooltip' | translate"
            [attr.aria-label]="'notifications.settings.tooltip' | translate"
            (click)="goToPreferences()">
      <mat-icon>settings</mat-icon>
    </button>
  </div>

  <!-- Filtros por tipo -->
  <div class="filters" role="group" [attr.aria-label]="'notifications.filter.label' | translate">
    <button type="button"
            class="filter-chip"
            [class.selected]="isAllSelected()"
            (click)="selectAll()">
      {{ 'notifications.filter.all' | translate }}
    </button>
    @for (meta of types; track meta.type) {
      <button type="button"
              class="filter-chip"
              [class.selected]="selectedTypes().has(meta.type)"
              (click)="toggleType(meta.type)">
        <mat-icon class="chip-icon" [style.color]="selectedTypes().has(meta.type) ? '#fff' : meta.color">{{ meta.icon }}</mat-icon>
        {{ ('notifications.type.' + meta.type + '.short') | translate }}
      </button>
    }
  </div>

  <!-- Lista con lazy loading por scroll -->
  <div class="list" (scroll)="onScroll($event)">
    @if (items().length === 0 && loading()) {
      <div class="list-state">
        <mat-spinner diameter="32"></mat-spinner>
      </div>
    } @else if (items().length === 0 && loadError()) {
      <div class="list-state">
        <mat-icon class="state-icon">cloud_off</mat-icon>
        <p class="state-title">{{ 'notifications.load-error' | translate }}</p>
        <button mat-stroked-button (click)="load(true)">{{ 'notifications.retry' | translate }}</button>
      </div>
    } @else if (items().length === 0) {
      <div class="list-state">
        <mat-icon class="state-icon">notifications_none</mat-icon>
        @if (isAllSelected()) {
          <p class="state-title">{{ 'notifications.empty.title' | translate }}</p>
          <p class="state-subtitle">{{ 'notifications.empty.subtitle' | translate }}</p>
        } @else {
          <p class="state-title">{{ 'notifications.empty.filtered' | translate }}</p>
        }
      </div>
    } @else {
      @for (n of items(); track n.id) {
        <div class="item"
             [class.unseen]="!n.seen"
             [class.clickable]="!!n.link"
             role="button"
             tabindex="0"
             (click)="openItem(n)"
             (keydown.enter)="openItem(n)">
          <div class="item-icon" [style.background]="iconBg(n.type)">
            <mat-icon [style.color]="metaFor(n.type).color">{{ metaFor(n.type).icon }}</mat-icon>
          </div>
          <div class="item-body">
            <p class="item-message">{{ svc.messageFor(n) }}</p>
            <span class="item-time">{{ svc.relativeTime(n.createdAt, now()) }}</span>
          </div>
          @if (!n.seen) {
            <span class="unseen-dot" aria-hidden="true"></span>
          }
          <button mat-icon-button
                  class="item-delete"
                  [matTooltip]="'notifications.delete-one' | translate"
                  [attr.aria-label]="'notifications.delete-one' | translate"
                  (click)="deleteItem(n, $event)">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      }
      @if (loading()) {
        <div class="loading-more">
          <mat-spinner diameter="22"></mat-spinner>
        </div>
      }
    }
  </div>

  <!-- Pie de acciones -->
  <div class="panel-footer">
    @if (confirmingClear()) {
      <span class="confirm-question">{{ 'notifications.clear-confirm' | translate }}</span>
      <span class="footer-spacer"></span>
      <button mat-button class="confirm-no" (click)="cancelClearAll()">{{ 'notifications.confirm.no' | translate }}</button>
      <button mat-flat-button color="warn" class="confirm-yes" (click)="confirmClearAll()">{{ 'notifications.confirm.yes' | translate }}</button>
    } @else {
      <button mat-button
              class="footer-action"
              [disabled]="svc.unseenCount() === 0"
              (click)="markAllSeen()">
        <mat-icon>done_all</mat-icon>
        {{ 'notifications.mark-all-seen' | translate }}
      </button>
      <span class="footer-spacer"></span>
      <button mat-button
              class="footer-action footer-clear"
              [disabled]="items().length === 0"
              (click)="askClearAll()">
        <mat-icon>delete_sweep</mat-icon>
        {{ 'notifications.clear-all' | translate }}
      </button>
    }
  </div>
</div>
